import React from 'react';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setNotification } from '../../../../actions/appNotifications';
import { appNotificationsTypes, responsiveSizeJobs } from '../../../../utils/constants';
import MainButton from '../MainButton';
import { useWindowSize } from '../../../../utils/hooks';

function ShareButton(props) {
  const { elemType = 'button', isLarge = false, title = '', text = '', url } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { width } = useWindowSize();

  const shareHandler = () => {
    if (navigator.share) {
      navigator.share({
        text,
        url,
        title
      });
    } else {
      dispatch(
        setNotification({
          type: appNotificationsTypes.SUCCESS,
          isAppStyled: true,
          message: t('common.general.copied'),
          duration: 3000
        })
      );
      navigator.clipboard.writeText(url);
    }
  };

  return (
    <MainButton outlined rounded action={shareHandler}>
      <ShareOutlinedIcon sx={{ fontSize: '18px' }} />
      <span style={{ marginLeft: '10px' }}>{t('common.general.share')}</span>
    </MainButton>
  );
}

export default ShareButton;
